import React from 'react';
import ReactDOM from 'react-dom';
import styles from './Modal.module.css';

function Modal({ isOpen, onClose, title, children, footer, size = 'md' }) {
  if (!isOpen) return null;

  const sizeClasses = {
    sm: styles.modalContentSm,
    md: styles.modalContentMd,
    lg: styles.modalContentLg,
    xl: styles.modalContentXl,
  };

  const modalWidthClass = sizeClasses[size] || sizeClasses.md;

  return ReactDOM.createPortal(
    <div className={styles.modalBackdrop}>
      <div className={`${styles.modalContent} ${modalWidthClass}`}>
        
        <div className={styles.modalHeader}>
          <h3 className={styles.modalTitle}>{title}</h3>
          <button onClick={onClose} className={styles.modalCloseButton}>
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path></svg>
          </button>
        </div>

        <div className={styles.modalBody}>
          {children}
        </div>

        {footer && (
          <div className={styles.modalFooter}>
            {footer}
          </div>
        )}
      </div>
    </div>,
    document.body
  );
}

export default Modal;